import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import type {LivePenaltiesModuleState} from "../models/live-penalties-module.state";
import type {LivePenaltiesModuleController} from "../live-penalties-module.controller";
import {LIVE_PENALTIES} from "../live-penalties-module.consts";
import {LivePenaltiesModulePlayerSwipeEventModel} from "../models/live-penalties-module.player-swipe.event-model";

export class LivePenaltiesModulePlayerSwipeEventHandler extends AnalyticsEventHandler {
  type = LIVE_PENALTIES.ACTION_TYPES.onPlayerSwipe;
  state: LivePenaltiesModuleState;
  controller: LivePenaltiesModuleController;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = LivePenaltiesModulePlayerSwipeEventModel;
  }
}
